import { cssVar } from '@fabric-app/ui/theme/variables';
import { motion } from 'framer-motion';
import { styled, css } from 'styled-components';

const BASE_BOTTOM_BAR_HEIGHT = `env(safe-area-inset-bottom) + 54px`;
const BottomBar = styled(motion.div).withConfig({
  displayName: "ResizableBottomBar__BottomBar",
  componentId: "sc-fc0e83f0-0"
})([
  `height:1px;flex-shrink:0;border-radius:1.5rem 1.5rem 0 0;background:`,
  `;min-height:calc(`,
  `);transform:translate3D(0,0,0);padding-bottom:env(safe-area-inset-bottom);padding-bottom:calc( env(safe-area-inset-bottom) - clamp( 0px,env(safe-area-inset-bottom),var(--keyboard-height,0px) ) );max-height:calc(100dvh - var(--keyboard-height,0px) - env(safe-area-inset-top) - 60px - 20px);[data-is-editor-focused='true'] &{display:none;}`
], cssVar["bg-expanded-resource-extra-panel"], BASE_BOTTOM_BAR_HEIGHT);
const activeCss = css([
  `&:before{transform:translate(-50%,-50%) scale(1.15);background:#e2e2e2;}`
]);
const DragHandle = styled(motion.div).withConfig({
  displayName: "ResizableBottomBar__DragHandle",
  componentId: "sc-fc0e83f0-1"
})([
  `height:18px;position:relative;flex-shrink:0;&:after{content:'';display:block;position:absolute;width:100%;height:70px;top:-24px;opacity:0;}&:before{content:'';display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#b2b2b2;height:6px;width:48px;border-radius:3px;transition:transform 0.125s ease-in-out;}`,
  ` &:active{`,
  `}[data-is-editor-focused='true'] &{display:none;}`
], ({ isActive }) => isActive && activeCss, activeCss);

export { BASE_BOTTOM_BAR_HEIGHT, BottomBar, DragHandle };
//# sourceMappingURL=ResizableBottomBar.js.map
